module.exports = __webpack_public_path__ + "static/media/travelandhospitality_img.2747fbcd.png";